import type { Location } from 'modules/core/lib/navigation/types'

export const productUpdatesNavigation = {
  path: 'news',
  children: {
    item: {
      path: ':slug',
    },
  },
} as const satisfies Location

export const autoOnboarding = {
  path: 'onboarding',
} as const satisfies Location

export const factorialOneNavigation = {
  path: 'factorial_one',
} as const satisfies Location
